export default "__VITE_ASSET__C02YGUFz__"